"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Request = require('superagent');

require('superagent-retry-delay')(Request);

var _Promise = require('bluebird');

var Hash = require('hash.js');

var queryString = require('query-string');

var _ = require('lodash');

var Auth = require('./modules/Auth');

var _require = require('./constants/url'),
    NO_AUTH_REQUIRED_URLS = _require.NO_AUTH_REQUIRED_URLS;

var Api =
/*#__PURE__*/
function () {
  function Api(_ref) {
    var _this = this;

    var apiUrls = _ref.apiUrls,
        storage = _ref.storage,
        eventEmitter = _ref.eventEmitter,
        apiKey = _ref.apiKey,
        _ref$sessionRecovery = _ref.sessionRecovery,
        sessionRecovery = _ref$sessionRecovery === void 0 ? false : _ref$sessionRecovery,
        _ref$requestMetadata = _ref.requestMetadata,
        requestMetadata = _ref$requestMetadata === void 0 ? true : _ref$requestMetadata;

    _classCallCheck(this, Api);

    this.storage = storage;
    this.sessionRecovery = Boolean(sessionRecovery);
    this.requestMetadata = Boolean(requestMetadata);
    this.apiUrls = apiUrls;
    this.eventEmitter = eventEmitter;
    this.auth = new Auth({
      api: this,
      apiKey: apiKey,
      storage: storage,
      eventEmitter: eventEmitter
    });
    this.sucseedOnce = false;
    return ['get', 'post', 'put', 'patch', 'delete'].forEach(function (method) {
      _this[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        /*
        [postProcessor]{fn}, url{string}, [[payload]{obj} or [payload:files]{array}], [callback]{fn}
        if prepare then [payload = arg[2]]
        else [payload = arg[1]]
        */
        var postProcessor = args[0],
            url = args[1],
            payload = args[2];
        var files;

        if (typeof postProcessor !== 'function') {
          // fix argument sequence = [url, [payload], [callback]]
          payload = url;
          url = postProcessor;
          postProcessor = null;
        }

        if (_typeof(payload) === 'object') {
          if (Array.isArray(payload)) {
            files = payload;
            payload = null;
          }
        } else {
          payload = null;
        }

        if (typeof files === 'function') {
          files = null;
        } // Весь этот позор надо переписать на передачу в запрос на массива аргументов, а объекта с ключами
        // Но для этого надо перебрать все запросы по SDK, поэтому пока подставлен вот такой костыль


        var last = args[args.length - 1];
        var callback = typeof last === 'function' ? last : null;

        var requestPromise = _this.makeRequest({
          type: method,
          url: url,
          payload: payload,
          files: files
        });

        if (postProcessor) {
          requestPromise = requestPromise.then(postProcessor);
        }

        if (callback) {
          requestPromise.then(function (result) {
            return callback(null, result);
          })["catch"](callback);
        }

        return requestPromise;
      };
    });
  }

  _createClass(Api, [{
    key: "getServerTime",
    value: function getServerTime(time) {
      var clientTime = time * 1000 || Date.now();
      return (clientTime + Number(this.storage.get('deltaTime'))) / 1000;
    }
  }, {
    key: "synchroniseTime",
    value: function synchroniseTime(responseBody) {
      if (_.get(responseBody, 'additionalInfo.serverTime')) {
        var serverTime = parseInt((responseBody.additionalInfo.serverTime * 1000).toString(), 10);
        var clientTime = Date.now();
        this.storage.set('deltaTime', serverTime - clientTime);
      }
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(request) {
      request.set('Cache-Control', 'no-cache');

      if (typeof window !== 'undefined') {
        // browser
        request.set('x-js-user-agent', this.storage.get('userAgent'));
      } else {
        // nodejs
        request.set('User-Agent', this.storage.get('userAgent'));
      }

      var accessToken = this.storage.get('accessToken');

      if (accessToken) {
        request.set('Authorization', "Bearer ".concat(accessToken));
      }
    }
  }, {
    key: "addToQueue",
    value: function addToQueue(data, params, timestamp) {
      var oldQueue = this.storage.get('queryQueue');
      var showLogs = this.storage.get('devMode');
      var newQueue = [].concat(_toConsumableArray(oldQueue), [{
        data: data,
        params: params,
        timestamp: timestamp
      }]);

      if (showLogs) {
        console.log('Request queue: ', newQueue);
      }

      this.storage.set('queryQueue', newQueue);
    }
  }, {
    key: "prepareQueue",
    value: function prepareQueue() {
      var queue = this.storage.get('queryQueue');
      /*
        * Оставляем только уникальные элементы очереди с помощью
        * _.uniqWith, затем сортируем по timestamp
      */

      var filteredQueue = _.uniqWith(queue, function (cur, next) {
        return _.isEqual(cur.data, next.data);
      });

      return _.sortBy(filteredQueue, ['timestamp']);
    }
  }, {
    key: "handleQueueSend",
    value: function handleQueueSend() {
      var _this2 = this;

      var queue = this.prepareQueue();
      this.storage.set('isSessionRecovering', false);
      this.storage.set('isSessionDestroyed', false);
      queue.forEach(function (item) {
        return _this2.sendRequest(item.data, item.params, item.timestamp);
      });
    }
  }, {
    key: "handleRecoverError",
    value: function handleRecoverError() {
      var queue = this.prepareQueue();
      this.storage.set('isSessionRecovering', false);
      this.eventEmitter.emit('destroyed.session');
      queue.forEach(function (item) {
        return item.params.reject(new Error('Unauthorized'));
      });
    }
  }, {
    key: "prepareRequest",
    value: function prepareRequest(req) {
      var _req$type = req.type,
          type = _req$type === void 0 ? 'get' : _req$type,
          payload = req.payload,
          files = req.files;
      var url = req.url;
      var request = Request[type](url.includes('http') ? url : this.apiEndpoint + url); // Set retry count, see https://www.npmjs.com/package/superagent-retry-delay

      request.retry(2, 3000, [400, 401, 402, 403, 404, 424, 429]);
      var requestBody;

      if (payload) {
        if (type === 'get') {
          request.query(payload).sortQuery();
          var qs = queryString.stringify(payload);
          url = "".concat(url, "?").concat(qs);
        } else {
          request.send(payload);
          requestBody = JSON.stringify(payload);
        }
      }

      if (files) {
        files.forEach(function (file) {
          if (file.type === 'audio') {
            request.attach('file', file.src).field('hash', file.hash).field('duration', file.duration);
          } else {
            request.attach(file.name, file.photo);
          }
        });
      }

      this.setHeaders(request);
      return request;
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(req) {
      var _this3 = this;

      if (!req) {
        return _Promise.reject(new Error('request parameter is required'));
      }

      var timestamp = Date.now();
      return new _Promise(function (resolve, reject) {
        return _this3.sendRequest(req, {
          resolve: resolve,
          reject: reject
        }, timestamp);
      });
    }
  }, {
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(req, params, timestamp) {
        var _this4 = this;

        var request, isAuthorized, resolve, reject, isSessionDestroyed, sessionRecovery;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!req.url.includes('auth-companion-service/v1/refresh-token') && !req.url.includes('application/features'))) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.auth.keycloak.checkAndRefreshToken();

              case 3:
                request = this.prepareRequest(req);
                isAuthorized = !!this.storage.get('accessToken');
                resolve = params.resolve, reject = params.reject;
                isSessionDestroyed = this.storage.get('isSessionDestroyed');
                sessionRecovery = this.sessionRecovery; // TODO handle check for "unstoppable" requests like session recover

                if (!(sessionRecovery && isSessionDestroyed && !NO_AUTH_REQUIRED_URLS.includes(req.url))) {
                  _context2.next = 11;
                  break;
                }

                this.addToQueue(req, {
                  resolve: resolve,
                  reject: reject
                }, timestamp);
                return _context2.abrupt("return");

              case 11:
                request.end(
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee(error) {
                    var res,
                        responseBody,
                        status,
                        _args = arguments;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            res = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                            if (!error) {
                              _context.next = 19;
                              break;
                            }

                            if (!(error.status === 401 && request.header.Authorization && request.header.Authorization.includes('Bearer'))) {
                              _context.next = 4;
                              break;
                            }

                            return _context.abrupt("return", _this4.auth.keycloak.refreshToken().then(function (response) {
                              if (!response || !response.error) {
                                _this4.sendRequest(req, params, timestamp);
                              }
                            }));

                          case 4:
                            _this4.eventEmitter.emit('xhr.error', error);

                            if (!(error.status === 401 && isAuthorized)) {
                              _context.next = 9;
                              break;
                            }

                            _this4.recoverSession({
                              req: req,
                              resolve: resolve,
                              reject: reject,
                              error: error,
                              timestamp: timestamp
                            });

                            _context.next = 17;
                            break;

                          case 9:
                            if (!(!error.status && _this4.apiUrls.online && !_this4.apiUrls.hostsRequested && !_this4.sucseedOnce)) {
                              _context.next = 16;
                              break;
                            }

                            _context.next = 12;
                            return _this4.apiUrls.fetchApiHosts();

                          case 12:
                            _context.next = 14;
                            return _this4.sendRequest(req, params, timestamp);

                          case 14:
                            _context.next = 17;
                            break;

                          case 16:
                            reject(error);

                          case 17:
                            _context.next = 24;
                            break;

                          case 19:
                            responseBody = res.body;
                            status = res.status;
                            _this4.sucseedOnce = true;

                            _this4.synchroniseTime(responseBody);

                            if (_this4.requestMetadata) {
                              resolve(res);
                            } else {
                              if (status === 201) {
                                responseBody.is201 = true;
                              }

                              resolve(responseBody);
                            }

                          case 24:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendRequest(_x, _x2, _x3) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }, {
    key: "recoverSession",
    value: function recoverSession(_ref3) {
      var _this5 = this;

      var req = _ref3.req,
          resolve = _ref3.resolve,
          reject = _ref3.reject,
          timestamp = _ref3.timestamp,
          error = _ref3.error;
      var sessionRecovery = this.sessionRecovery;
      var isSessionRecovering = this.storage.get('isSessionRecovering');
      var recoverDelay = this.storage.get('sessionRecoverDelay') || 0;

      if (sessionRecovery) {
        this.storage.set('isSessionDestroyed', true);

        if (!isSessionRecovering) {
          this.storage.set('isSessionRecovering', true);
          setTimeout(function () {
            return _this5.auth.recoverSession({}, function (err, data) {
              if (err) {
                _this5.handleRecoverError();
              } else {
                _this5.storage.saveSession(data);

                _this5.handleQueueSend();
              }
            });
          }, recoverDelay);
        }

        this.addToQueue(req, {
          resolve: resolve,
          reject: reject
        }, timestamp);
      } else {
        this.eventEmitter.emit('destroyed.session');
        reject(error);
      }
    }
  }, {
    key: "apiEndpoint",
    get: function get() {
      return this.apiUrls.urls.apiEndpoint;
    }
  }, {
    key: "chatApiUrl",
    get: function get() {
      return this.apiEndpoint;
    }
  }]);

  return Api;
}();

module.exports = Api;